import Reveal from "./Reveal";
import { TESTIMONIALS } from "../data/content";
import { Quote } from "lucide-react";

export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="relative py-12 lg:py-16">
      <div className="max-w-6xl mx-auto px-5">
        <Reveal className="text-center max-w-2xl mx-auto">
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-sky-400">Social Proof</p>
          <h2 className="mt-3 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white">
            Hear From Breeze Financial's Top Agents
          </h2>
          <p className="mt-3 text-sm sm:text-base text-slate-400">
            See exactly what agents & leaders have to say about working with Breeze.
          </p>
        </Reveal>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.12}>
              <div
                data-testid={`testimonial-card-${i}`}
                className="glass-card rounded-3xl p-7 h-full flex flex-col hover:border-sky-400/40 transition-colors duration-300 group"
              >
                <Quote className="h-6 w-6 text-sky-400/70 group-hover:text-sky-300 transition-colors" />
                <p className="mt-4 text-sm leading-relaxed text-slate-300 flex-1">
                  “{t.quote}
                  <strong className="text-white">{t.bold}</strong>
                  {t.suffix || ""}”
                </p>
                <div className="mt-6 flex items-center gap-3">
                  <div className="relative">
                    <div className="absolute -inset-0.5 rounded-full bg-gradient-to-tr from-sky-400 to-blue-600 opacity-70 blur-[3px]" aria-hidden="true" />
                    <img
                      src={t.img}
                      alt={t.name}
                      loading="lazy"
                      className="relative h-12 w-12 rounded-full object-cover border border-white/20"
                    />
                  </div>
                  <div>
                    <div className="text-sm font-bold text-white">{t.name}</div>
                    <div className="text-xs text-sky-300/90 italic">{t.role}</div>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
